import { render, staticRenderFns } from "./group_products.vue?vue&type=template&id=a74825c0&scoped=true&"
import script from "./group_products.vue?vue&type=script&lang=js&"
export * from "./group_products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74825c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a74825c0')) {
      api.createRecord('a74825c0', component.options)
    } else {
      api.reload('a74825c0', component.options)
    }
    module.hot.accept("./group_products.vue?vue&type=template&id=a74825c0&scoped=true&", function () {
      api.rerender('a74825c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/modifiers/groups/tabs/group_products.vue"
export default component.exports